import type { PlayEventParticipant, PublicPlayEventParticipant } from '@court-sync/shared';
import { getPlayEventParticipantAvatarProps } from '@court-sync/shared';
import { UserAvatar } from '@/components/UserAvatar';
import { cn } from '@/lib/utils';

type AvatarSize = 'sm' | 'md' | 'lg';

type PlayEventParticipantLike = PlayEventParticipant | PublicPlayEventParticipant;

interface PlayEventParticipantAvatarProps {
  participant: PlayEventParticipantLike;
  size?: AvatarSize;
  className?: string;
}

export function PlayEventParticipantAvatar({
  participant,
  size = 'md',
  className,
}: PlayEventParticipantAvatarProps) {
  const props = getPlayEventParticipantAvatarProps(participant);
  return (
    <UserAvatar
      avatarUrl={props.avatarUrl}
      firstName={props.firstName}
      lastName={props.lastName}
      displayName={props.displayName}
      size={size}
      className={className}
    />
  );
}

interface PlayEventParticipantRowProps {
  participant: PlayEventParticipantLike;
  size?: AvatarSize;
  align?: 'left' | 'right';
  nameClassName?: string;
}

export function PlayEventParticipantRow({
  participant,
  size = 'md',
  align = 'left',
  nameClassName,
}: PlayEventParticipantRowProps) {
  const props = getPlayEventParticipantAvatarProps(participant);

  return (
    <div
      className={cn(
        'flex min-w-0 items-center gap-2',
        align === 'right' && 'flex-row-reverse text-right'
      )}
    >
      <PlayEventParticipantAvatar participant={participant} size={size} className="shrink-0" />
      <span
        className={cn(
          'min-w-0 truncate font-semibold leading-snug text-gray-900 dark:text-white',
          nameClassName
        )}
      >
        {props.displayName ??
          [props.firstName, props.lastName].filter(Boolean).join(' ').trim()}
      </span>
    </div>
  );
}
